<template>
  <stat-card :card-list="list"/>
</template>

<script>
  import StatCard from "@view/components/StatCard"
  export default {
    name: "UserDeviceCount",
    components: {StatCard},
    data() {
      return {
        list: [
          {icon: "el-icon-s-shop", text: "商家总数 / 有效商家 / 在线商家", count: [{val:0},{val:0},{val:0}], color: "#27A9E3"},
          {icon: "el-icon-s-shop", text: "今日新增商家数", count: 0, color: "#0CCA8E"},
          {icon: "el-icon-s-platform", text: "设备总数 / 设备在线数", count: [{val:0},{val:0}], color: "#27A9E3"},
        ]
      }
    },
    created() {
      this.getShopData();
      this.getDeviceData();
    },
    methods: {
      async getShopData() {
        let res = await this.$Http.getShopCount();
        if (res?.data) {
          this.list[0].count[0].val = +res.data.total || 0;
          this.list[0].count[1].val = +res.data.binded || 0;
          this.list[0].count[2].val = +res.data.online || 0;
          this.list[1].count = +res.data.today_new || 0;
        }
      },
      async getDeviceData() {
        let res = await this.$Http.getDeviceCount();
        if (res?.data) {
          this.list[2].count[0].val = +res.data.total || 0;
          this.list[2].count[1].val = +res.data.online || 0;
        }
      }
    }
  }
</script>

<style scoped>

</style>
